module.exports = __webpack_public_path__ + "sunsemweb/img/abanner.46573e30.png";